module.exports = __webpack_public_path__ + "img/uruguay-logo-icon.afe30db9.png";